import { inject, Injectable, Signal, signal, WritableSignal } from '@angular/core';
import { ToastService } from '@open/ngx-components/toast';
import { LayoutConfig } from './page-header.model';

@Injectable({
  providedIn: 'root',
})
export class LayoutService {
  readonly #toastService: ToastService = inject(ToastService);

  readonly #configState: WritableSignal<LayoutConfig> = signal<LayoutConfig>({ isCollapsed: true });
  readonly #isLoadingState: WritableSignal<boolean> = signal<boolean>(false);

  readonly config: Signal<LayoutConfig> = this.#configState.asReadonly();
  readonly isLoading: Signal<boolean> = this.#isLoadingState.asReadonly();

  startLoading(): this {
    this.#isLoadingState.set(true);
    return this;
  }

  stopLoading(): this {
    this.#isLoadingState.set(false);
    return this;
  }

  clearConfig(): this {
    this.#configState.set({});
    return this;
  }

  setConfig(config: LayoutConfig): this {
    this.#configState.update((current: LayoutConfig) => ({ ...current, ...config }));
    return this;
  }

  resetConfig(): this {
    return this.setConfig({
      title: '',
      subTitle: '',
      isPinky: false,
      isPublicGroup: false,
      isTransparent: false,
    });
  }

  openMenu(): void {
    this.setConfig({ isCollapsed: false });
  }

  closeMenu(): void {
    this.setConfig({ isCollapsed: true });
  }

  createSuccessMessage(text: string, durationInMilliseconds: number): void {
    this.#toastService.presentToast({ message: text, borderColor: 'success', pos: 'top', duration: durationInMilliseconds });
  }

  createWarningMessage(text: string, durationInMilliseconds: number): void {
    this.#toastService.presentToast({ message: text, borderColor: 'warning', pos: 'top', duration: durationInMilliseconds });
  }

  createErrorMessage(text: string, durationInMilliseconds: number): void {
    this.#toastService.presentToast({ message: text, borderColor: 'danger', pos: 'top', duration: durationInMilliseconds });
  }
}
